import {Bubbles} from '@management-ui/core';
import {withTheme} from '@mui/styles';
import React from 'react';
import withTaskStatuses from './withTaskStatuses';
import {taskStatus} from '../utilities';

const TaskStatus = ({task, statuses}) => (
  <Bubbles bubbles={statuses.filter(({key}) => key === taskStatus(task)).map(({title, colour}) => (
    {
      id: 0,
      label: title,
      colour: colour
    }
  ))}/>
);

export default withTaskStatuses(withTheme(TaskStatus));
